"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8584],{

/***/ 40590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ use100Vh)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/*
set --100vh custom variable on style root

:root{
 --100vh: 100vh
}

*/

var VAR = '--100vh'; // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

var set100VhCssVar = function set100VhCssVar() {
  var vh = window.innerHeight;
  document.documentElement.style.setProperty(VAR, vh + "px");
};

function use100Vh() {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    window.addEventListener('resize', set100VhCssVar);
    return function () {
      window.removeEventListener('resize', set100VhCssVar);
    };
  }, []);
  return [set100VhCssVar];
}




/***/ }),

/***/ 33509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ useHasMounted)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

function useHasMounted() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}




/***/ }),

/***/ 56437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ useNetwork)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91917);



function useNetwork() {
  var navigatorOnline = _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_1__/* .isOnClient */ .BK ? window.navigator.onLine : true;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(navigatorOnline),
      isOnline = _useState[0],
      setNetwork = _useState[1];

  var updateNetwork = function updateNetwork() {
    setNetwork(window.navigator.onLine);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('offline', updateNetwork);
    window.addEventListener('online', updateNetwork);
    return function () {
      window.removeEventListener('offline', updateNetwork);
      window.removeEventListener('online', updateNetwork);
    };
  });
  return [isOnline];
}




/***/ }),

/***/ 19485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JK": () => (/* binding */ useGoCashBalanceStore),
/* harmony export */   "tQ": () => (/* binding */ useBookingSummaryStore),
/* harmony export */   "y7": () => (/* binding */ selectUpcomingBookingsCount),
/* harmony export */   "yL": () => (/* binding */ useLoyaltyUserInfoStore),
/* harmony export */   "yY": () => (/* binding */ selectLoyaltyMemberType)
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40624);
/* harmony import */ var _growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36880);
/* harmony import */ var _growth_api_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92878);




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var useBookingSummaryStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_STATE */ .L, {
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: _growth_api_calls__WEBPACK_IMPORTED_MODULE_2__/* .fetchBookingSummary */ .YH,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

/** Filter the 'UPCOMING' bookings */
var selectUpcomingBookingsCount = function selectUpcomingBookingsCount(state) {
  var _state$data;
  var bookingList = (state == null || (_state$data = state.data) == null ? void 0 : _state$data.bookingDetails) || [];
  var upcomingList = bookingList.filter(function (item) {
    return (item == null ? void 0 : item.status) === 'UPCOMING';
  });
  return upcomingList.length;
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var fetchFun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var resp, _ref2, success, balance;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,_growth_api_calls__WEBPACK_IMPORTED_MODULE_2__/* .fetchGoCashBalance */ .z1)();
        case 2:
          resp = _context.sent;
          _ref2 = resp || {}, success = _ref2.success, balance = _ref2.total_credits;
          if (!(success || typeof balance !== 'undefined')) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            balance: balance
          });
        case 6:
          return _context.abrupt("return", 0);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchFun() {
    return _ref.apply(this, arguments);
  };
}();
var useGoCashBalanceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_STATE */ .L, {
    data: {
      balance: 0
    },
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var useLoyaltyUserInfoStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_STATE */ .L, {
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: _growth_api_calls__WEBPACK_IMPORTED_MODULE_2__/* .fetchLoyaltyUserInfo */ .aL,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

// https://github.com/pmndrs/zustand/discussions/387#discussioncomment-6339994
var selectLoyaltyMemberType = function selectLoyaltyMemberType(state) {
  var _state$currentTier;
  return (state == null || (_state$currentTier = state.currentTier) == null ? void 0 : _state$currentTier.tierNumber) || null;
};




/***/ }),

/***/ 12830:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ow": () => (/* binding */ epocToDate)
/* harmony export */ });
/* unused harmony exports dateToEPOC, getDateFormat, getYearsAgoDate, getYearsAgoDateFromNow, isDateExpired */
var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      format = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (format) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};




/***/ }),

/***/ 53767:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": () => (/* binding */ headingSizes),
/* harmony export */   "iH": () => (/* binding */ textSizes),
/* harmony export */   "xv": () => (/* binding */ Text)
/* harmony export */ });
/* unused harmony exports Box, Heading, breakPoints, buildTheme, colors, defaultTheme, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal'; //  Lable

var textSizes = {
  LargeW1: {
    'font-weight': fwRegular,
    'font-size': fs18,
    'line-height': lhAuto
  },
  LargeW2: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwMedium
  },
  LargeW3: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwRegular
  },
  MediumW2: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwMedium
  },
  MediumW3: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  },
  BaseW1: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwRegular
  },
  BaseW2: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwMedium
  },
  BaseW3: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwSemiBold
  },
  SmallW1: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwRegular
  },
  SmallW2: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwMedium
  },
  SmallW3: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwSemiBold
  }
}; //  Lable

var headingSizes = {
  xLarge: {
    'font-weight': fwBold,
    'font-size': fs32,
    'line-height': lhAuto
  },
  Large: {
    'line-height': lhAuto,
    'font-size': fs24,
    'font-weight': fwBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs22,
    'font-weight': fwSemiBold
  },
  Small: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  Base: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  }
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: {
    label: _extends({}, textSizes),
    heading: _extends({}, headingSizes)
  }
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0
var spacing$1 = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};

var buildSpacing = function buildSpacing() {
  return spacing$1;
};

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}

var Box = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(function (_ref) {
  var _ref$mr = _ref.mr,
      mr = _ref$mr === void 0 ? '' : _ref$mr,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? '' : _ref$mt,
      _ref$ml = _ref.ml,
      ml = _ref$ml === void 0 ? '' : _ref$ml,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? '' : _ref$mb,
      _ref$my = _ref.my,
      my = _ref$my === void 0 ? '' : _ref$my,
      _ref$mx = _ref.mx,
      mx = _ref$mx === void 0 ? '' : _ref$mx,
      _ref$pt = _ref.pt,
      pt = _ref$pt === void 0 ? '' : _ref$pt,
      _ref$pr = _ref.pr,
      pr = _ref$pr === void 0 ? '' : _ref$pr,
      _ref$pb = _ref.pb,
      pb = _ref$pb === void 0 ? '' : _ref$pb,
      _ref$pl = _ref.pl,
      pl = _ref$pl === void 0 ? '' : _ref$pl,
      _ref$py = _ref.py,
      py = _ref$py === void 0 ? '' : _ref$py,
      _ref$px = _ref.px,
      px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing$1[mr || mx] || '') + ";\n\tmargin-left: " + (spacing$1[ml || mx] || '') + ";\n\tmargin-top: " + (spacing$1[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing$1[mb || my] || '') + ";\n\tpadding-right: " + (spacing$1[pr || px] || '') + ";\n\tpadding-left: " + (spacing$1[pl || px] || '') + ";\n\tpadding-top: " + (spacing$1[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing$1[pb || py] || '') + ";\n";
});

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$1;
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .ZP.p(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});

var _templateObject;
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2 */ .ZP.h2(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return headingSizes[size || 'Large'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});




/***/ }),

/***/ 63377:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ DomEventEmitter)
/* harmony export */ });
var DomEventEmitter = function () {
  return {
    on: function on(eventName, listener) {
      return document.addEventListener(eventName, listener);
    },
    off: function off(eventName, listener) {
      return document.removeEventListener(eventName, listener);
    },
    emit: function emit(eventName, opts) {
      var event = new CustomEvent(eventName, {
        detail: opts,
        cancelable: true
      });
      return document.dispatchEvent(event);
    }
  };
}();




/***/ }),

/***/ 46871:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ob": () => (/* binding */ promiseDelay)
/* harmony export */ });
/* unused harmony exports addScript, isArrowDownKey, isArrowLeftKey, isArrowRightKey, isArrowUpKey, isEnterEvent */
var isEnterEvent = function isEnterEvent(event) {
  var keyCode = event.key;
  return keyCode === 'Enter';
};

var isArrowDownKey = function isArrowDownKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowDown';
};

var isArrowUpKey = function isArrowUpKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowUp';
};

var isArrowLeftKey = function isArrowLeftKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowLeft';
};

var isArrowRightKey = function isArrowRightKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowRight';
};

var addScript = function addScript(scriptURl, opts) {
  if (typeof window !== 'undefined') {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptURl;
    script.async = opts.async || false;
    script.onload = opts.onload || null;
    var position = document.querySelector(opts.position || 'body');

    if (position) {
      position.append(script);
    }
  }
};

// this method add delay in resolving the promise
var promiseDelay = function promiseDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};




/***/ }),

/***/ 26147:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ Footer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _growth_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53767);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);




function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$3;
var Style$2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n\t.footer-links {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 0;\n\t}\n\n\ta {\n\t\ttext-decoration: none;\n\t\tcursor: pointer;\n\t}\n\n\t.footer-links ul {\n\t\twidth: 25%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tlist-style: none;\n\t}\n\n\t.footer-links ul li {\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.footer-links ul li:first-child {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 12px;\n\t\tcolor: #000;\n\t\tmargin-bottom: 15px;\n\t\tfont-weight: 700;\n\t}\n\n\t.footer-links ul li a {\n\t\tdisplay: inline-flex;\n\t\tcolor: #777;\n\t\tfont-size: 12px;\n\t\tfont-family: Helvetica, sans-serif;\n\t}\n"])));

function FooterLinks(_ref) {
  var adobe = _ref.adobe;

  var sendEvent = function sendEvent(e) {
    var _e$target, _e$target2;

    adobe == null ? void 0 : adobe.track('ctaClick', {
      cta: {
        name: (_e$target = e.target) == null ? void 0 : _e$target.innerText,
        destination: (_e$target2 = e.target) == null ? void 0 : _e$target2.getAttribute('href'),
        componentName: 'footer',
        type: 'link'
      }
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style$2, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    role: "presentation",
    className: "footer-links",
    onClick: sendEvent
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "our products")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Domestic Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels-international/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "International Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Domestic Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/international-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "International Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/multicity-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Multi-City Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cfhotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Couple Friendly Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Nearby Getaways"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/bus/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Bus Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cab Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/airport-cabs/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Airport Cabs Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Outstation Cabs Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Train Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/gostays/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Go Stay"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.tripmoney.com/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Trip Money"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://advertising.goibibo.com/ad/solutions/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Goibibo Advertising Solutions")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "about us")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/aboutus/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "About Us"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/investors-overview/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Investor Relations"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/management/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Management"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/terms-of-services/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Terms of Services"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/user-agreement/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "User Agreement"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/privacy/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Privacy"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/careers/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Careers"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.youtube.com/user/goibibo",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "YouTube Channel"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://tech.goibibo.com/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Technology@Goibibo"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/customerHelp/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Customer Support"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.facebook.com/Goibibo/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Facebook Page"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://twitter.com/goibibo",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Twitter Handle")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "travel essentials")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/check-pnr-status/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "PNR Status"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/offers/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Offers"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/city-to-city-airlines/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Airline Routes"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/check-train-running-status/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Train Running Status")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "more links")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/cheap-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cheap Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/hotels-near-me/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Hotels Near Me"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/trips/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "My Bookings"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/trips/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cancellation"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/myaccount/settings/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "My Account"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/myaccount/gocash/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Wallet"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://advertising.goibibo.com/ad/solutions/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Advertise with Us"))))));
}

var _templateObject$2;
var Styles = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\t.footer-app-links {\n\t\tdisplay: flex;\n\t\tborder-bottom: solid 1px rgba(0, 0, 0, 0.2);\n\t\tpadding: 15px 0;\n\t\t-webkit-box-pack: justify;\n\t\tjustify-content: space-between;\n\t}\n\n\t.footer-app-links .follow-us {\n\t\tdisplay: flex;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\tfont-size: 14px;\n\t\tfont-weight: 700;\n\t}\n\n\t.footer-app-links .follow-us .social-icons {\n\t\tmargin-top: 10px;\n\t}\n\n\t.footer-app-links .follow-us .store-icons {\n\t\tmargin-top: 10px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.footer-app-links .payment-icons {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.footer-sprite.facebookIcon {\n\t\tbackground-position: -213px -3px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.twitterIcon {\n\t\tbackground-position: -241px -3px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.youTubeIcon {\n\t\tbackground-position: -268px -3px;\n\t\twidth: 30px;\n\t\theight: 25px;\n\t}\n\n\t.footer-sprite.playStoreIcon {\n\t\tbackground-position: -0px -1px;\n\t\twidth: 107px;\n\t\theight: 38px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.appStoreIcon {\n\t\tbackground-position: -107px -1px;\n\t\twidth: 106px;\n\t\theight: 37px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.verifySign {\n\t\tbackground-position: -1px -41px;\n\t\twidth: 60px;\n\t\theight: 30px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.amricanIcon {\n\t\tbackground-position: -63px -41px;\n\t\twidth: 31px;\n\t\theight: 30px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.masterCardIcon {\n\t\tbackground-position: -97px -40px;\n\t\twidth: 49px;\n\t\theight: 33px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.visaIcon {\n\t\tbackground-position: -149px -40px;\n\t\twidth: 46px;\n\t\theight: 34px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.ruPayIcon {\n\t\tbackground-position: -5px -85px;\n\t\twidth: 84px;\n\t\theight: 23px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.iataIcon {\n\t\tbackground-position: -199px -43px;\n\t\twidth: 40px;\n\t\theight: 30px;\n\t}\n\n\t.footer-copyrights {\n\t\tborder-top: 1px solid #e6e6e6;\n\t\tpadding-top: 20px;\n\t\tpadding-bottom: 20px;\n\t\tcolor: #b3b3b3;\n\t\tfont-size: 11px;\n\t\tline-height: 1;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t.footer-sprite.mmtLogo {\n\t\tbackground-position: -8px -120px;\n\t\twidth: 98px;\n\t\theight: 32px;\n\t\tmargin-right: 30px;\n\t\tposition: relative;\n\t\t-webkit-filter: grayscale(100%);\n\t\tfilter: grayscale(100%);\n\t\topacity: 0.5;\n\t}\n\n\t.footer-sprite.redBusLogo {\n\t\tbackground-position: -56px -166px;\n\t\twidth: 65px;\n\t\theight: 32px;\n\t\t-webkit-filter: grayscale(100%);\n\t\tfilter: grayscale(100%);\n\t\topacity: 0.6;\n\t}\n\n\t.footer-copyrights a:hover .redBusLogo,\n\t.footer-copyrights a:hover .mmtLogo {\n\t\t-webkit-filter: grayscale(0);\n\t\tfilter: grayscale(0);\n\t\topacity: 1;\n\t}\n"])));

var FooterAppLinks = function FooterAppLinks() {
  var year = new Date().getFullYear();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Styles, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-app-links"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "follow-us"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "Follow Us"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "social-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://www.facebook.com/goibibo",
    title: "facebook",
    rel: "noreferrer",
    "aria-label": "Facebook"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite facebookIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://twitter.com/goibibo",
    title: "Twitter",
    rel: "noreferrer",
    "aria-label": "Twitter"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite twitterIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://www.youtube.com/user/goibibo",
    title: "youtube",
    rel: "noreferrer",
    "aria-label": "youtube"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite youTubeIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://plus.google.com/+goibibo/",
    className: "fl",
    title: "Google Plus",
    rel: "noreferrer",
    "aria-label": "Google Plus"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "hd_vs fr_gplus margin0"
  }, "\xA0")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "follow-us"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "Book Tickets faster. Download our mobile Apps"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "store-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://play.google.com/store/apps/details?id=com.goibibo&referrer=af_tranid%3DvxsPvRUmXy7VkUyrYCgpaQ%26pid%3Dmobile_site%26c%3Dm_header%26af_web_id%3Df6a83147-2300-4c5b-860d-d0a4e2e56160-c%26utm_source%3Dmobile_site%26utm_campaign%3Dm_header",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite playStoreIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://apps.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite appStoreIcon"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "payment-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite verifySign"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite amricanIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite masterCardIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite visaIcon "
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite ruPayIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite iataIcon"
  }, "\xA0"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-copyrights"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "brand-name"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.makemytrip.com/",
    target: "_black"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite mmtLogo"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.redbus.in/",
    target: "_black"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite redBusLogo"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1",
    as: "span",
    className: "sc-iqAclL fNjDal"
  }, "\xA9 ", year, " Makemytrip (India) Private Limited. All rights reserved")));
};

var _templateObject$1;
var Style$1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t.footer-dl {\n\t\tdisplay: flex;\n\t\tborder: solid 1px rgba(0, 0, 0, 0.2);\n\t\tborder-left: none;\n\t\tborder-right: none;\n\t\tpadding: 15px 0;\n\t}\n\n\t.footer-dl ul {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: 5px 0;\n\t\tpadding: 0;\n\t\tlist-style: none;\n\t}\n\n\t.footer-dl ul li {\n\t\tfont-size: 12px;\n\t\tcolor: #b3b3b3;\n\t\tline-height: 16px;\n\t}\n\n\t.footer-dl ul li:first-child {\n\t\tfont-weight: 700;\n\t\tpadding-right: 10px;\n\t}\n\n\t.footer-dl ul li a {\n\t\tcolor: #b3b3b3;\n\t\tpadding: 0px 3px 0 0;\n\t}\n"])));

function FooterDirectLinks(_ref) {
  var data = _ref.data,
      adobe = _ref.adobe;

  var sendEvent = function sendEvent(dl) {
    adobe == null ? void 0 : adobe.track('ctaClick', {
      cta: {
        name: dl.text,
        destination: dl.url,
        componentName: 'footer',
        type: 'link'
      }
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style$1, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-dl"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, data.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
      key: item.title
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, item.title), item.links && item.links.map(function (dl, index, arr) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
        key: dl.text
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: dl.url,
        onClick: function onClick() {
          return sendEvent(dl);
        }
      }, dl.text, " ", arr.length - 1 === index ? '' : ' |'));
    }));
  }))));
}

var _templateObject;
var Style = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t.happy-gi-footer {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbackground: #fff;\n\t\tcolor: #000;\n\t\tfont-size: 16px;\n\t\tfont-family: 'QuickSand,Helvetica,Arial,sans-serif', sans-serif;\n\t\tfont-weight: 400;\n\t}\n\n\t.happy-gi-footer .footer-container {\n\t\twidth: 1100px;\n\t\tmargin: 0 auto;\n\t}\n\n\t.footer-sprite {\n\t\tbackground: url(https://gos3.ibcdn.com/footer-sprite-1688459091.png) no-repeat;\n\t\tbackground-size: 300px 200px;\n\t\tdisplay: -webkit-inline-flex;\n\t\tdisplay: -ms-inline-flexbox;\n\t\tdisplay: inline-flex;\n\t\t-webkit-flex-shrink: 0;\n\t\tflex-shrink: 0;\n\t}\n"])));

function Footer(_ref) {
  var data = _ref.data,
      adobe = _ref.adobe;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("footer", {
    className: "happy-gi-footer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterLinks, {
    adobe: adobe
  }), data && data.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterDirectLinks, {
    data: data,
    adobe: adobe
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterAppLinks, null))));
}




/***/ })

}]);